import { useMemo } from 'react';
import { useAppSelector } from './redux';
import { selectUser } from '../../common/store/slices/auth.slice';
import { selectModules } from '../store/slices/page-config.slice';
import { useModuleProjectContext } from 'common/contexts/useModuleProjectContext';
import { getSearchIndexName } from 'common/utils/searchIndexName';

export const useModuleProject = () => {
  const { activeProject } = useModuleProjectContext();
  const user = useAppSelector(selectUser);
  const modules = useAppSelector(selectModules);

  const moduleData = useMemo(() => {
    return {
      moduleId: modules?.length > 0 ? modules?.[0].moduleID : 0,
      projectId: activeProject?.moduleProjectID ?? '',
      searchIndexName: getSearchIndexName(activeProject?.projectClientName),
    };
  }, [activeProject, modules]);

  const moduleUserData = useMemo(() => {
    return {
      ...moduleData,
      userId: user.id,
      projectName: activeProject?.projectDisplayName,
    };
  }, [moduleData, user, activeProject]);

  const feedbackData = useMemo(() => {
    return {
      moduleId: modules?.length > 0 ? modules[0].moduleID : 0,
      projectId: activeProject?.moduleProjectID,
      userId: user.id || '0',
    };
  }, [activeProject, user, modules]);

  return { moduleData, moduleUserData, feedbackData };
};
